import { Customer } from '~/lib/api/smartsend/types';
import { Registered } from '../../../lib/consts/TaxStatusConsts';
import { EoriNumber, IossNumber } from '../../../lib/consts/ItemMetaConstants';
import {
  EoriNumberGbValidation,
  EoriNumberValidation,
  IossNumberValidation
} from '../../../lib/consts/ItemMetaValidationConstants';

const ValidateCustomerAccountDetails = (address: Customer): boolean => {
  if (address.Meta[IossNumber]?.Value && RegExp(IossNumberValidation).test(address.Meta[IossNumber]?.Value) === false) {
    return false;
  }

  if (
    address.Meta[EoriNumber]?.Value &&
    RegExp(address.CountryIsoCode === 'GBR' ? EoriNumberGbValidation : EoriNumberValidation).test(
      address.Meta[EoriNumber]?.Value
    ) === false
  ) {
    return false;
  }

  return (
    !!address.Name && !!address.Email && !!address.Phone && (address.VatStatus !== Registered || !!address.VatNumber)
  );
};
export default ValidateCustomerAccountDetails;
